import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";
import "./app-extra.css";
import "./manual-athlete.css";
import "./attendance-controls.css";
import "./calendar-management.css";
import "./scout.css";
import "./athlete-profile.css";
import "./boxscore.css";
import "./brand-theme.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode><App /></React.StrictMode>,
);
